import $ from 'jquery';
import Swiper from 'Swiper';
import 'pannellum';
import { throttle } from './utils';

const isDesktopWidth = () => window.innerWidth >= 992;

function setSwiperPaging() {
    const $slides = $('.swiper-slide');
    const len = $slides.length;
    if (len) {
        $slides.each(function(i){
            $(this).find('.paging > h4').text(`${i+1}/${len}`);
        });
    }
}

function checkEmptySection() {
    $('.portfolio-section').each(function(){
        const title = $(this).find('li:nth-child(1) .portfolio-intro-info--title').text();
        const body = $(this).find('li:nth-child(2) .portfolio-intro-info--body').text();
        if (!title.length && !body.length) {
            $(this).find('.portfolio-intro--info').addClass('empty');
        }
    })
}

function handleSwiperProgress({ progress = 0 } = {}) {
    const $progress = $('#swiperProgress');
    $progress.css('width', `${progress * 100}%`);
}

export function handlePostSwipe() {
    let swiper;

    const addSwiper = () => {
        const $container = $('.swiper-container');
        if ($container.length === 0) return;
        swiper = new Swiper('.swiper-container', {
            loop: false,
            on: {
                init: (sw) => {
                    const handleClickNext = () => {
                        if(sw.isEnd) {
                            document.querySelector('#nextPage > a').click();
                        } else {
                            sw.slideNext();
                        }
                    }
                    const handleClickPrev = () => {
                        if (sw.isBeginning) {
                          document.querySelector('#prevPage > a').click();
                        } else {
                          sw.slidePrev();
                        }
                    }
                    $container.find('.button__next').off('click').on('click', handleClickNext);
                    $container.find('.swiper-button-next').off('click').on('click', handleClickNext);
                    $container.find('.swiper-button-prev').off('click').on('click', handleClickPrev);
                },
                slideChange() {
                    handleSwiperProgress(swiper);
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            touchRatio: 0,
        });
    }

    const refreshSwiper = () => {
        if (!swiper) return;
        swiper.update();
    }

    const destroySwiper = () => {
        if (!swiper) return;
        swiper.destroy();
    }


    let viewer;
    const $viewerWrap = $('#viewerWrap');
    const pathnameRegExp = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/;

    const showViewer = ($img) => {
        if (window.pannellum) {
            const match = ($img.attr('src') || '').match(pathnameRegExp);
            if (match) {
                viewer = pannellum.viewer('panorama', {
                    type: "equirectangular",
                    panorama: `/${match[3]}`,
                    autoLoad: true
                });
                $viewerWrap.show();
            }
        } else {
            console.warn('cannot found pannellum module');
        }
    }

    const hideViewer = () => {
        if (viewer) viewer.destroy();
        $viewerWrap.hide();
    }

    const checkMetaPort = ($videoInfo) => {
        return $videoInfo && $videoInfo.length > 0 && $videoInfo.text().indexOf('matterport') > 0;
    }

    const $videoWrap = $('#videoWrap');
    const $videoFrame = $('#videoFrame');
    const vimeoRegExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;

    const showFrame = ($videoInfo) => {
        const match = ($videoInfo.text() || '').match(vimeoRegExp);
        if (match) {
            $videoFrame.attr('src', `https://player.vimeo.com/video/${match[3]}?autoplay=1`);
            $videoWrap.show();
        } else if (checkMetaPort($videoInfo)) {
            $videoFrame.attr('src', $videoInfo.text());
            $videoWrap.show();
        }
    };

    const hideVideo = () => {
        $videoWrap.hide();
        $videoFrame.attr('src', '');
    };


    const handleViewer = () => {
        $('.button__vr').off('click').on('click', (e) => {
            const $img = $(e.target).parents('.swiper-slide').find('.portfolio-gallery img').first();
            showViewer($img);
        });
        $('#btnCloseVr').off('click').on('click', () => {
            hideViewer();
        });
        $('#viewerWrap .backdrop').off('click').on('click', () => {
            hideViewer();
        });
        $('.button__video').off('click').on('click', (e) => {
            const $videoInfo = $(e.target).parents('.swiper-slide').find('.portfolio-video').first();
            showFrame($videoInfo);
        });
        $('#btnCloseVideo').off('click').on('click', (e) => {
            hideVideo();
        });
        $('#videoWrap .backdrop').off('click').on('click', () => {
            hideVideo();
        })

        // 버튼 이름 변경
        $('.portfolio-video').each((i, el) => {
            const $this = $(el);
            if (checkMetaPort($this)) {
                $this.parent().find('.button__video').text('3D View');
            }
        })
    }

    const init = () => {
        setSwiperPaging();
        if (isDesktopWidth()) {
            addSwiper();
        }
        window.addEventListener('resize', throttle(() => {
            if (isDesktopWidth()) {
                if (!swiper || swiper.destroyed) {
                    addSwiper();
                } else if (swiper) {
                    refreshSwiper();
                }
            } else if (swiper && !swiper.destroyed) {
                destroySwiper();
            }
        }));
        handleViewer();
        checkEmptySection();
    }

    init();
}
